import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  getCurrentAuthUser,
  subscribeToAuthChanges,
} from "../services/authDataService";

function ProtectedRoute({ children }) {
  const [checking, setChecking] = useState(true);
  const [user, setUser] = useState(null);

  const location = useLocation();

  useEffect(() => {
    let mounted = true;
    let unsubscribe = null;

    const init = async () => {
      try {
        const currentUser = await getCurrentAuthUser();

        if (mounted) {
          setUser(currentUser || null);
          setChecking(false);
        }

        unsubscribe = await subscribeToAuthChanges((nextUser) => {
          if (!mounted) return;
          setUser(nextUser || null);
          setChecking(false);
        });
      } catch (error) {
        console.warn("ProtectedRoute init failed:", error);
        if (mounted) {
          setUser(null);
          setChecking(false);
        }
      }
    };

    init();

    return () => {
      mounted = false;

      if (typeof unsubscribe === "function") {
        const maybePromise = unsubscribe();
        if (maybePromise?.catch) maybePromise.catch(() => {});
      }
    };
  }, []);

  if (checking) {
    return <div style={{ textAlign: "center", marginTop: 40 }}>Lade...</div>;
  }

  // ❌ nicht eingeloggt → Zielseite merken
  if (!user?.uid) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }}
      />
    );
  }

  // ❌ Email nicht bestätigt → Zielseite ebenfalls merken
  if (user.emailVerified === false) {
    return (
      <Navigate
        to="/confirmation"
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
}

export default ProtectedRoute;